<template>
    <div v-if="shouldShowDash">
        <span>-</span>
    </div>
    <date-time-with-note
        v-else
        :details="details"
        :comment="comment"
        type="punch-out"
    />
</template>

<script>
import DateTimeWithNote from "./AttendanceRequest/DateTimeWithNote";
import {filterLastPendingData} from "../Helper/Helper";

export default {
    name: "PunchOutDateTime",
    components: {DateTimeWithNote},
    props: {
        value: {},
        tableId: {},
    },
    computed: {
        details(){
            if (this.tableId === 'attendance-request-table'){
                return filterLastPendingData(this.value);
            }

            return this.collection(this.value).first();
        },
        comment() {
            if (this.details.comments) {
                return this.collection(this.details.comments.filter(comment => comment.type === 'out-note')).first();
            }
            return {};
        },
        shouldShowDash() {
            // Check if in_time and out_time are the same
            if (this.details && this.details.in_time && this.details.out_time) {
                const inTime = new Date(this.details.in_time).getTime();
                const outTime = new Date(this.details.out_time).getTime();
                return inTime === outTime;
            }
            return false;
        }
    }
}
</script>

<style scoped>

</style>